import React, { useEffect, useState } from "react";
import { BaseUrl } from "../../../../Container/BaseUrl/BaseUrl";
import axios from "axios";
import { toast } from "react-toastify";
import { connect } from "react-redux";
import {

  endInteraction,
  setExternalChatData,
} from "../../../../Redux/Actions/actions";
import FormControl from "@mui/material/FormControl";
import {
  Slide,
  DialogTitle,
  DialogContentText,
  DialogContent,
  DialogActions,
  Dialog,
  Stack,
  Button,
} from "@mui/material";
import { GitMerge } from "@phosphor-icons/react";
import { toaststyle } from "../../../../Utils/toaststyle";

const mapStateToProps = (state) => {
  return {
    chatid: state.data.chatid,
    chat: state.data.chat,
  };
};

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const Conferancesupervisormodel = (props) => {
  const { show, close, chatid, chat, OpenDialog, handleClose } = props;
  const [availableAgent, setAvailableAgent] = useState([]);
  const [agentTransferId, setAgentTransferId] = useState("agent");
  const [showTransferMod, setShowTransferMod] = useState(false);
  const [checkWhichCall, setCheckWhichCall] = useState("");
  const [showfiltersupervisor, setShowfiltersupervisor] = useState(false);
  const [supervisorValidation, setSupervisorValidation] = useState(false);

  const transferAgent = (val) => {
    setCheckWhichCall(val);
    setShowTransferMod(true);
  };

  const handleTransferClose = () => {
    setAgentTransferId("agent");
    setShowTransferMod(false);
  };

  const handleTransfersupervisorClose = () => setShowfiltersupervisor(false);
  const handleTransfersupervisorOpen = (val) => {
    setShowfiltersupervisor(true);
    setCheckWhichCall(val);
  };

  useEffect(() => {
    getAvailableAgents();
  }, []);

  const getAvailableAgents = async () => {
    const access_token = localStorage.getItem("access_token");

    try {
      let userId = JSON.parse(localStorage.getItem("tokenAgent"));
      let passUserId = userId.user_id;
      const data = await axios.post(
        BaseUrl + "/users/listSupervisor",
        {},
        {
          headers: {
            Authorization: "Bearer " + access_token,
            "Content-Type": "application/json",
            tenantId: localStorage.getItem("TenantId"),
          },
        }
      );
      if (data.data.status) {
        setAvailableAgent(data.data.data);
      }
    } catch (error) {
      // errorHandel(error, "/users/listSupervisor")
    }
  };

  const conferanceSupervisorSubmit = async () => {
    try {
      let selectedChat = JSON.parse(localStorage.getItem("client"));
      let old_agent_id = JSON.parse(localStorage.getItem("tokenAgent"));
      const selectedOption =
        agentTransferId.options[agentTransferId.selectedIndex];
      const selectedName = selectedOption.text;
      const selectedId = selectedOption.value;

      if (selectedName === "agent") {
        alert("select agent");
        return false;
      }
      let message_to_pass = `Conference with ${old_agent_id.username} and ${selectedName}`;

      await axios
        .post(
          BaseUrl + "/users/conferenceAgent",
          {
            sessionId: selectedChat.chat_session_id,
            agentId: selectedId,
            oldAgentId: old_agent_id.id,
          },
          {
            headers: {
              Authorization: "Bearer " + localStorage.getItem("access_token"),
              "Content-Type": "application/json",
              tenantId: localStorage.getItem("TenantId"),
            },
          }
        )
        .then(async (res) => {
          if (res.data.status) {
            handleClose();
            await axios.post(
              BaseUrl + "/message/addMessage",
              {
                from: old_agent_id.id,
                to: selectedChat.id,
                message: message_to_pass,
                senderName: old_agent_id.username,
                receiverName: selectedChat.username,
                messageFrom: "fromAgent",
                userType: selectedChat.chat_type,
                session: selectedChat.chat_session_id,
                msg_sent_type: "NOTIFICATIONS",
              },
              {
                headers: {
                  tenantId: localStorage.getItem("TenantId"),
                },
              }
            );

            props.endInteraction();
            props.setExternalChatData("");
            localStorage.removeItem("client");
            toast.success("Conferenced to supervisor success", toaststyle);
          } else {
            props.setExternalChatData("");
            handleClose();
            toast.warn(data.data.message, toaststyle);
          }
        })
        .catch((err) => {
          console.log("conferanceSupervisorSubmit", err);
        });
    } catch (error) {
      console.log("conferanceSupervisorSubmit", error);
    }
  };

  return (
    <>
      <Dialog
        open={OpenDialog}
        keepMounted
        onClose={handleClose}
        aria-describedby="alert-dialog-slide-description"
        maxWidth="sm"
        fullWidth
      >
        <DialogTitle
          variant="subtitle2"
          sx={{ fontSize: "16px", fontWeight: 600, boxShadow: "rgba(50, 50, 93, 0.25) 0px 2px 5px -1px, rgba(0, 0, 0, 0.3) 0px 1px 3px -1px" }}
        >
          Conference to supervisor
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-slide-description">
            <Stack className="mt-3" sx={{ display: "flex", justifyContent: "center"}}>
            <label for="formFile" className="form-label fs-13">Supervisor</label>
              <select
                className={`form-select fs-13 form-select-sm ${supervisorValidation ? "is-invalid" : ""
                  }`}
                name="availableAgent"
                onChange={(e) => setAgentTransferId(e.target)}
              >
                <option value="agent" selected>
                Select available supervisor
                </option>
                {availableAgent.map((agents) => {
                  return (
                    <option value={agents.id}>
                      {agents.username ? agents.username : agents.firstName}
                    </option>
                  );
                })}
              </select>
              {supervisorValidation && (
                <div className="invalid-feedback fs-13">
                  Please select a Supervisor
                </div>
              )}
            </Stack>
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button
            sx={{ textTransform: "capitalize !important" }}
            variant="outlined"
            onClick={() => {
              handleClose();
            }}
            size="small"
            disableElevation
            color="error"
            autoFocus
          >
            Close
          </Button>
          <Button
            onClick={() => {
              if (agentTransferId === "agent") {
                setSupervisorValidation(true);
              } else {
                conferanceSupervisorSubmit();
              }
            }}
            sx={{ textTransform: "capitalize !important" }}
            variant="contained"
            size="small"
            disableElevation
          >
            {checkWhichCall}
            CONFERENCE
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default connect(mapStateToProps, {

  endInteraction,
  setExternalChatData,
})(Conferancesupervisormodel);
